var map = {
	"./angle-down-black.svg": 4864,
	"./angle-down-white.svg": 3977,
	"./building.svg": 3265,
	"./bus.svg": 215,
	"./check-circle.svg": 5490,
	"./check.svg": 5809,
	"./clock.svg": 5316,
	"./close.svg": 4167,
	"./date-black.svg": 6164,
	"./destination-black-bordered.svg": 6129,
	"./destination-black.svg": 8555,
	"./destination-white.svg": 8925,
	"./doublearrow-left-white.svg": 1411,
	"./favorite.svg": 6418,
	"./favorited.svg": 6805,
	"./ferry.svg": 432,
	"./gps-black.svg": 1843,
	"./gps-white.svg": 7517,
	"./institution.svg": 3352,
	"./loading.svg": 2819,
	"./logo.svg": 1937,
	"./logo_clean.svg": 4113,
	"./logo_editable.svg": 2398,
	"./microphone.svg": 8100,
	"./option-selected.svg": 7781,
	"./option.svg": 3564,
	"./origin-black-bordered.svg": 8928,
	"./origin-black.svg": 2029,
	"./origin-white.svg": 9614,
	"./pin-black.svg": 758,
	"./pin-white.svg": 9796,
	"./position.svg": 8857,
	"./shop.svg": 651,
	"./stop-primary.svg": 1844,
	"./stop-secondary.svg": 5535,
	"./street.svg": 4589,
	"./subway.svg": 234,
	"./swap-black.svg": 7598,
	"./train.svg": 3179,
	"./tram.svg": 4189,
	"./trolley.svg": 8525,
	"./walk-bg-vert.svg": 8563,
	"./walk-bg.svg": 7701,
	"./walk.svg": 9538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;